import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

// Keep skeleton structure aligned with ProductDetailsPage
const ProductDetailsPageSkeleton = () => {
  return (
    <div className={styles.productDetailsContainer}>
      <div className={styles.productDetailsBox}>
        {/* Gallery */}
        <div className={styles.productGallery}>
          <Skeleton height={400} width="100%" />
          <div className={styles.thumbnails}>
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton
                key={i}
                height={64}
                width={64}
                className={styles.skeletonThumb}
              />
            ))}
          </div>
        </div>

        {/* Right side info */}
        <div className={styles.productDetailsRight}>
          {/* Title */}
          <Skeleton height={28} width="70%" />

          {/* Price */}
          <div className={styles.skeletonPrice}>
            <Skeleton height={30} width={140} />
          </div>

          {/* Description */}
          <div className={`${styles.descriptionSection} ${styles.skeletonSectionSpacing}`}>
            <Skeleton count={4} height={14} />
          </div>

          {/* Meta (category/brand/model/year) */}
          <div className={`${styles.productDetailsMeta} ${styles.skeletonSectionSpacing}`}>
            <Skeleton height={16} width="85%" />
            <Skeleton height={16} width="75%" className={styles.skeletonMetaLine} />
            <Skeleton height={16} width="70%" className={styles.skeletonMetaLine} />
            <Skeleton height={16} width="60%" className={styles.skeletonMetaLine} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPageSkeleton;
